import React from 'react'
import PropTypes from 'prop-types'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import ValueProp from '../global/ValueProp'
import Container from '../global/Container'

const PageHeroComponent = ({ audience, data, className }) => {
  
  return (
    <div className={className}>
      <div className={`${audience}-page`}>
        <div className="hero-text">
          <Container>
            <h1>{data.heroTitle}</h1>
          </Container>
        </div>
        <ValueProp className="value-prop" content={data.value} />
        <div className="foreground" 
          style={{
            backgroundImage: `url(${
              data.heroFg.childImageSharp
                ? data.heroFg.childImageSharp.fluid.src
                : data.heroFg
            })`,
          }}
        ></div>
        <div className="background" 
          style={{
            backgroundImage: `url(${
              data.heroBg.childImageSharp
                ? data.heroBg.childImageSharp.fluid.src
                : data.heroBg
            })`,
          }}
        ></div>
      </div>
    </div>
  )
}

PageHeroComponent.propTypes = {
  audience: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  className: PropTypes.string
}

const PageHero = styled(PageHeroComponent)`
  ${tw`overflow-hidden bg-cover relative w-full`}
  height: 85vh;
  min-height: 750px;
  @media (max-width: 639px) {
    height: 600px;
    min-height: auto;

  }
  .hero-text {
    ${tw`w-full absolute text-white`}
    z-index: 2;
    top: 18%;
    left: 0;
    h1 {
      font-size: 140px;
      line-height: 90%;
      @media (max-width: 1023px) {
        font-size: 100px;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
    }
  }
  .foreground, .background {
    ${tw`overflow-hidden bg-cover absolute w-full`}
    height: 100%;
    top: 0;
  }
  .foreground { z-index: 3; 
    background-position: center;
  }
  .background { z-index: 1; 
    background-position: center;
  }
  .mailing-list {
    position: absolute;
    bottom: 15vh;
    z-index: 5;
    left: 0;
    width: 100%;
  }
  .mailing-list-form {
    float: right;
  }
  .value-prop .shadow {
    opacity: 0.8;
  }
  .value-prop .content {
    font-size: 0.9rem;
  }
  .businesses-page .value-prop .shadow .content {
    background-color: #D9CFC7 !important;
  }
  .schools-page .value-prop .foreground .content {
    font-size: 0.9rem;
  }
  .schools-page .value-prop .shadow .content {
    background-color: #00ADEE !important;
  }
  .businesses-page .hero-text h1 {
    padding-right: 40%;
    @media (max-width: 1250px) {
      font-size: 80px;
    }
    @media (max-width: 639px) {
      padding-top: 40px;
      font-size: 50px;
    }
    @media (max-width: 479px) {
      font-size: 40px;
    }
  }
  .schools-page .hero-text {
    top: 16%;
    padding-left: 35%;
    > div {
      width: 100%;
    }
    @media (max-width: 767px) {
      top: 24%;
    }
    @media (max-width: 479px) {
      padding-left: 10%;
    }
    h1 {
      font-size: 120px;
      line-height: 90%;
      @media (max-width: 1023px) {
        font-size: 100px;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
      @media (max-width: 639px) {
        font-size: 50px;
      }
    }
  }
`

export default PageHero
